import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {IAssignedProject} from '../../../batches/projects/project';
import {HelpersService} from '../../helpers.service';
import {ProjectsService} from '../../../batches/projects/projects.service';

@Component({
    selector: 'app-assigned-projects',
    templateUrl: './assigned-projects.component.html',
    styleUrls: ['./assigned-projects.component.scss'],
    standalone: false
})
export class AssignedProjectsComponent {

  @Input() formGroup: FormGroup;

  _initialProjectIds: number[];
  private _projectsLoaded = true;
  @Output() onChange = new EventEmitter();

  @Input()
  set initialProjectIds(projectIds: number[]) {
    if (projectIds === null) {
      projectIds = [];
    }

    if (this.helpersService.arraysEqual(this._initialProjectIds, projectIds)) {
      // already computed assigned projects
      return;
    }

    this._initialProjectIds = projectIds;
    this._projectsLoaded = false;
    this.projectsService.getAllProjectsWithAssignedInfo(this._initialProjectIds).subscribe(next => {
        this.assignedProjects = next.items;
        this._projectsLoaded = true;
      },
      error => this._projectsLoaded = true);
  }

  assignedProjects: IAssignedProject [] = [];

  public get updatedProjectIds() {
    if (!this._projectsLoaded) {
      return this.initialProjectIds;
    }

    const updatedProjectIds: number[] = [];
    this.assignedProjects.forEach(assignedProject => {
      if (assignedProject.assigned) {
        updatedProjectIds.push(assignedProject.project.id);
      }
    });
    return updatedProjectIds;
  }

  constructor(
    public helpersService: HelpersService,
    public projectsService: ProjectsService,
  ) {
  }

  toggleProject(assignedProject: IAssignedProject) {
    assignedProject.assigned = !assignedProject.assigned;
    this.onChange.emit(assignedProject);
    this.formGroup.markAsDirty();
  }


}
